import Vue from 'vue'
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import "./theme/index.css"
import ElementLocale from 'element-ui/lib/locale'
import App from './App.vue'
import router from './router'
import store from './store'
// import VueI18n from 'vue-i18n'
import i18n from "../public/lang"
import ErrorPlugin from "./plugins//error";
import filters from "./filter/filter"
import "./plugins/errorHandler"
import utils from "./util/util"
import "./filters"
import "./app.scss";

Vue.config.productionTip = false

Vue.prototype.utils = utils

Vue.use(ElementUI);

// Vue.use(VueI18n);

Vue.use(ErrorPlugin);

Vue.use(filters);

Vue.prototype.$message = function (options) {
  ElementUI.Message({
    duration: 5000,
    ...options
  })
}

// 語言包（i18n）
// import LangZHTW from '../public/lang/ZH_TW'
// import LangZHCN from '../public/lang/ZH_CN'
// import LangPT from '../public/lang/PT'
// import LangEN from '../public/lang/EN'

// const i18n = new VueI18n({
//   locale: localStorage.getItem('lan') || 'ZH_TW',
//   messages: {
//     'ZH_TW': LangZHTW,
//     'ZH_CN': LangZHCN,
//     'PT': LangPT,
//     'EN': LangEN,
//   }
// })
// ElementLocale.i18n((key, value) => i18n.t(key, value))

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// 日期格式化
Vue.filter('formatDT', function (value, format) {

  if (!value) return ''
  value = value.toString()
  const realDate = new Date(value)
  if (!format) {
    format = "dd/MM/yyyy HH:mm";
  }

  function timeFormat(num) {
    return num < 10 ? '0' + num : num;
  }

  var date = [
    ["M+", timeFormat(realDate.getMonth() + 1)],
    ["d+", timeFormat(realDate.getDate())],
    ["H+", timeFormat(realDate.getHours())],
    ["m+", timeFormat(realDate.getMinutes())],
    ["s+", timeFormat(realDate.getSeconds())],
    ["q+", Math.floor((realDate.getMonth() + 3) / 3)],
    ["S+", realDate.getMilliseconds()],
  ];
  var regYear = new RegExp("(y+)", "i");
  var reg1 = regYear.exec(format);
  if (reg1) {

    format = format.replace(reg1[1], (realDate.getFullYear() + '').substring(4 - reg1[1].length));
  }
  for (var i = 0; i < date.length; i++) {
    var k = date[i][0];
    var v = date[i][1];

    var reg2 = new RegExp("(" + k + ")").exec(format);
    if (reg2) {
      format = format.replace(reg2[1], reg2[1].length == 1 ?
        v : ("00" + v).substring(("" + v).length));
    }
  }
  // if (format.indexOf(" ") != -1) {
  //   format = format.replace(' ', ` ${ptWord} `);
  // }
  return format
})



// 大寫中文
Vue.filter('capitalLetter', function (val) {
  const num = parseInt(val);
  const numberToCN = ['〇', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十',
    '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八', '十九',
    '二十', '二十一', '二十二', '二十三', '二十四', '二十五', '二十六', '二十七',
    '二十八', '二十九', '三十', '三十一', '三十二', '三十三', '三十四', '三十五',
    '三十六', '三十七', '三十八', '三十九', '四十', '四十一', '四十二', '四十三', '四十四', '四十五', '四十六',
    '四十七', '四十八', '四十九', '五十', '五十一', '五十二', '五十三', '五十四', '五十五', '五十六',
    '五十七', '五十八', '五十九'
  ];
  return numberToCN[num];
})

// 文件大小
Vue.filter('formatFS', function (value) {
  if (value < (1024 * 1024)) {
    let temp = value / 1024;
    temp = temp == 0 ? temp : temp.toFixed(2);
    return temp + 'KB';
  } else if (value < (1024 * 1024 * 1024)) {
    let temp = value / (1024 * 1024);
    temp = temp.toFixed(2);
    return temp + 'MB';
  } else {
    let temp = value / (1024 * 1024 * 1024);
    temp = temp.toFixed(2);
    return temp + 'GB';
  }
})

console.log(
  `\n${process.env.VUE_APP_VERSION} ${process.env.VUE_APP_ENV || ''}\n\n`
);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')